module.exports = __webpack_public_path__ + "img/finance.30341180.svg";